declare global {
  interface Window {
    _env: {
      [Key: string]: string;
    };
  }
}

export const { authority, clientId: client_id, graphqlUri, environment } = window._env;

declare global {
  type remote = {
    name: string;
    entry: string;
  };
}
declare global {
  interface Window {
    _init_modules: {
      name: string;
      remotes: remote[];
    };
  }
}

export const INIT_MODULES = window._init_modules;
